import React, { useState, useEffect, useMemo } from "react";
import config from "../../config/config";
import Loader from "../Loader/Loader";
import axios from "axios";
import { Box, Button, Modal } from "@mui/material";
import { Noimage } from "../../common/imagePath";
import CommonMatrialReactTable from "../Datatable/CommonMatrialReactTable";
import { toastError, toastSuccess } from "../../common/Toast";
import { Link, useNavigate } from "react-router-dom";
import { checkUserPermission } from "../../common/UserPermission";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import ItemsDetailsModal from "./ItemsDetailsModal";

const InventorySubModulesRecordsModal = ({
  Module,
  ModuleId,
  runApi,
  closepopup,
  Name,
  columnsToExport = [],
}) => {
  console.log(Module, ModuleId, runApi, closepopup, Name, "checkall");
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const locationId = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [dropdownData, setDropdownData] = useState({ value: 0, label: "" });
  const [selectedId, setSelectId] = useState(0);
  const [rowSelection, setRowSelection] = useState({});
  const [rowSelectData, setRowSelectData] = useState([]);
  const [itemsDetailsDataId, setItemsDetailsDataId] = useState();
  const [isShowOnlyParents, setShowOnlyParents] = useState(0);

  console.log(selectedId, "rowSelectData");

  let PERMISSION_EDIT = "/manage-items/:id";
  let navigate = useNavigate();
  const handleClose = () => {
    setGlobalFilter("");
    setData([]);
    setRowSelection({});
    setRowSelectData([]);
    closepopup();
  };
  const style = {
    height: 750,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 1,
  };

  const handleChange = (e) => {
    console.log(e, "check event");
    const checked = e.target.checked ? 1 : 0;
    setShowOnlyParents(checked);
  };

  useEffect(() => {
    fetchListData();
  }, [isShowOnlyParents]);

  // Item search input change to set suggetions and valuee
  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleItemsDetailsData = (id) => {
    //  api call
    closepopup();
    setItemsDetailsDataId(id);
  };

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
    console.log(result, "checkresult");
  }, [rowSelection]);

  // Get Item List by Tag/Brand/Manufacturer
  const fetchListData = () => {
    axios
      .get(
        `${config.tagBaseUrl}/tags/TagBrandsManufacturerById?Module=${Module}&ID=${ModuleId}&locationId=${locationId}&isShowOnlyParents=${isShowOnlyParents}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setInputValue("");
        setSuggestions([]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // If want to remove Tag/Brand/Manufacturer
  const handleDelete = (Module, ModuleId, ItemID) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (confirmDelete) {
      setLoading(true);
      axios
        .get(
          `${config.tagBaseUrl}/tags/tagBrandManufacturerItemdeletebyid?Module=${Module}&ModuleID=${ModuleId}&itemid=${ItemID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          toastSuccess("Tag removed from item successfully");
          fetchListData(); // Recall the API after successful delete
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastError("Something went wrong!");
        });
    }
  };

  useEffect(() => {
    if (Module === "Brand") {
      axios
        .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          const datalist = res.data.ResponseData.map((u) => {
            return { label: u.Name, value: u.ID };
          });
          setDropdownData(datalist);
          // setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else if (Module === "Tag") {
      axios
        .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          const datalist = res.data.ResponseData.map((u) => {
            return { label: u.Name, value: u.ID };
          });
          setDropdownData(datalist);
        });
    } else if (Module === "Category") {
      axios
        .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          const datalist = res.data.ResponseData.map((u) => {
            return { label: u.Name, value: u.ID };
          });
          setDropdownData(datalist);
        });
    } else {
      axios
        .get(
          `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const datalist = res.data.ResponseData.map((u) => {
            return { label: u.Name, value: u.ID };
          });
          setDropdownData(datalist);
        });
    }
  }, []);

  useEffect(() => {
    if (runApi) {
      fetchListData(); // Fetch the data when component mounts or when the dependencies change
    }
  }, [Module, ModuleId, runApi]);

  // Item search API
  const fetchData = async (inputValue) => {
    if (inputValue != "") {
      axios
        .get(
          `${config.itemsBaseUrl}/items/searchitem?searchparam=${inputValue}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            if (data[0].ItemId > 0) {
              setSuggestions(data);
            } else {
              setSuggestions([]);
            }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  // SET INPUT VALUE FOR ITEM SEARCH
  useEffect(() => {
    setTimeout(() => {
      fetchData(inputValue);
    }, 500);
  }, [inputValue]);

  // const handleMove = (pID) => {
  //   console.log(pID,"pIDs");
  //   const moveParameters = {
  //     ItemIds: pID,
  //     Module: Module,
  //     ModuleId: selectedId,
  //     OldModuleId: ModuleId,
  //     Loginuserid: loginUserId,
  //   };

  //   axios
  //     .post(
  //       `${config.tagBaseUrl}/tags/TagBrandMaufacturerItemsUpsert`,
  //       { moveParameters },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
  //         toastSuccess(`${Module} Added Successfully to Item(s)`);
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //       ) {
  //         toastError("Something Went Wrong");
  //       }
  //       setInputValue("");
  //       setSuggestions([]);
  //       fetchListData();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });

  // };

  //  List Columns
  const Modalcolumns = useMemo(() => [
    {
      header: "Item ID",
      accessorKey: "ID",
      size: 5,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                window.open(`/manage-Items/${row.original.ID}`, "_blank")
              }
            >
              {row.original.Item}
            </Box>
          )
        : ({ row }) => <>{row.original.Item}</>,
    },
    {
      header: "Item Name",
      accessorKey: "Name",
      Cell: ({ row }) => (
        <Link
          style={{
            borderRadius: "0.3rem",
            color: "#343f62",
            // maxWidth: "18ch",
            fontWeight: "600",
            // textDecoration:"underline",
            // textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          }}
          type="button"
          onClick={(e) => handleItemsDetailsData(row.original.ID)}
          data-bs-target="#ItemsDetailsModal"
          data-bs-toggle="modal"
          // style={{ color: "#000" }}
        >
          <div className="word-break-data" title={row.original.Name}>
            {row.original.VariationId === 0 && (
              <i className="fa fa-list-ul"></i>
            )}{" "}
            {row.original.Name}
          </div>
        </Link>
      ),
    },
    {
      header: "Item Image",
      size: 110,
      Cell: ({ row }) => (
        <>
          {row.original.ImageName ? (
            <a target="_blank" href={row.original.ImageName}>
              <img
                src={row.original.ImageName ? row.original.ImageName : Noimage}
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            </a>
          ) : (
            <img
              src={row.original.ImageName ? row.original.ImageName : Noimage}
              style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
            />
          )}
        </>
      ),
    },
    {
      header: "Action",
      size: 10,
      Cell: ({ row }) => (
        <button
          onClick={() =>
            handleDelete(Module, row.original.ModuleId, row.original.ID)
          }
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          <i className="fa fa-trash fs-4" style={{ color: "red" }}></i>
        </button>
      ),
    },
  ]);

  // Add selected Tag/Brand/Manufacturer to Item
  const handleInputClick = (pItemId) => {
    axios
      .post(
        `${config.tagBaseUrl}/tags/TagBrandMaufacturerItemsUpsert`,
        {
          ItemIds: pItemId,
          Module: Module,
          ModuleId: selectedId > 0 ? selectedId : ModuleId,
          OldModuleId: selectedId > 0 ? ModuleId : selectedId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(`${Module} "${Name}" Added Successfully to Item`);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Item Already assigned");
          toastError(`${Module} "${Name}" Already Added to Item`);
        }

        // toastSuccess({ Module } + " added successfully to item");
        setInputValue("");
        setSuggestions([]);
        setRowSelectData([]);
        setRowSelection({});
        setSelectId(0);
        fetchListData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <div>
        <Modal
          open={runApi}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="custom-header mb-2 mt-1">
              <p className="title-model w-80" id="exampleModalLabel">
                {Module}: {Name}
              </p>
              <div>
                <div className="mb-3" style={{ width: "400px" }}>
                  <div className="input-group flex-nowrap">
                    <span className="input-group-text" id="addon-wrapping">
                      <i
                        class="fa fa-search-plus fs-3"
                        style={{ color: "var(--secondary-main-color)" }}
                      ></i>
                    </span>

                    <input
                      type="text"
                      className="form-control h-auto"
                      placeholder="Type item name or scan barcode"
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                {suggestions.length > 0 ? (
                  <div
                    className="dropdown"
                    style={{ position: "relative", width: "400px" }}
                  >
                    <ul
                      className="dropdown-menu  show" //dropdown-suggestion
                      style={{
                        //  width: "100%",
                        maxHeight: "400px",
                        overflowY: "auto",
                      }}
                    >
                      {suggestions.map((item, index) => (
                        <li
                          key={item.ItemId}
                          style={{ cursor: "pointer" }}
                          className={"dropdown-item"}
                          onClick={(e) => handleInputClick(item.ItemId)}
                        >
                          <a
                            key={item.ItemId}
                            className={"dropdown-item"}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={item.images ? item.images : Noimage}
                              alt={item.ItemName}
                              className="img-thumbnail rounded-circle mr-5"
                              style={{
                                maxWidth: "55px",
                                maxHeight: "55px",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = Noimage;
                              }}
                            />
                            <div className="customer-info ml-2">
                              <h6 className="name">
                                {item.ItemName}
                                {item.VariationName
                                  ? `(${item.VariationName})`
                                  : ""}
                              </h6>
                            </div>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {rowSelectData?.length > 0 && (
                <>
                  <div className="col-md-2">
                    <div className="input-group">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        options={dropdownData}
                        placeholder={
                          Module === "Brand"
                            ? "Select Brand"
                            : Module === "Tag"
                            ? "Select Tag"
                            : Module === "Category"
                            ? "Select Category"
                            : "Select Manufacturer"
                        }
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="w-100 custom-search-select"
                        onChange={(selectedOption) =>
                          setSelectId(selectedOption ? selectedOption.value : 0)
                        }
                      />
                    </div>
                  </div>
                  <button
                    className="btn btn-primary btn-sm "
                    onClick={() => handleInputClick(rowSelectData.join(","))}
                  >
                    Move
                  </button>
                </>
              )}
              {Module === "Category" && (
              <div className="d-flex">
                <input
                  className="form-check-input mt-2 me-2"
                  style={{ width: "1.5em", height: "1.5em" }}
                  type="checkbox"
                  id="DefaultNewItemsAsServiceItems"
                  name="DefaultNewItemsAsServiceItems"
                  checked={isShowOnlyParents == 1 ? true : false}
                  onChange={(e) => handleChange(e)}
                />
                <label className="col-form-label form-label p-lg-medium">
                  Show Parent Category's Items
                </label>
              </div>
              )}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                {/* <span aria-hidden="true">×</span> */}
              </button>
            </div>
            <CommonMatrialReactTable
              columns={Modalcolumns}
              data={data}
              hodiExport={false}
              enableRowSelection={true}
              isRowSelectionManual={true}
              setRowSelectData={setRowSelection}
              state={{ rowSelection }}
              muiTableContainerProps={{
                sx: {
                  maxHeight: { xs: 300, sm: 350, md: 420, lg: 450, xl: 550 },
                },
              }}
              // columnsToExport={["ID", "Item", "Name", "Imagename", "CreatedDate", "Count", "ItemId", "ItemVariationId", "BrandID", "Brand", "CategoryID", "Category",  "TagID", "Tag", "ManufacturerID", "Manufacturer"]}
              columnsToExport={columnsToExport}
            />
          </Box>
        </Modal>
      </div>
      <ItemsDetailsModal
        id={itemsDetailsDataId}
        setItemsId={setItemsDetailsDataId}
      />
    </>
  );
};
export default InventorySubModulesRecordsModal;
